var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOverview = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.512,
    height: 14.229,
    viewBox: "0 0 17.512 14.229",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.512,10.865A8.876,8.876,0,0,0,8.756,2,8.876,8.876,0,0,0,0,10.865a8.783,8.783,0,0,0,.985,4.269H6.348a3.2,3.2,0,0,0,4.816,0h5.363A8.783,8.783,0,0,0,17.512,10.865ZM15.323,7.473V8.567L10.836,12.4a4.74,4.74,0,0,1,.109.547,2.189,2.189,0,1,1-2.189-2.189,2.062,2.062,0,0,1,.876.219l4.6-3.5ZM10.945,4.189h1.094V5.284H10.945Zm-5.472,0H6.567V5.284H5.472ZM2.189,12.945H1.094V11.851H2.189ZM3.283,8.567H2.189V7.473H3.283Zm13.134,4.378H15.323V11.851h1.094Z",
    transform: "translate(0 -2)",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.189,12.095A1.094,1.094,0,1,1,8.094,11,1.095,1.095,0,0,1,9.189,12.095Z",
    transform: "translate(0.661 -1.149)",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOverview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/overview.d0c2fb4f.svg";
export { ForwardRef as ReactComponent };